import script from "./Textarea.vue?vue&type=script&setup=true&lang=ts"
export * from "./Textarea.vue?vue&type=script&setup=true&lang=ts"

import "./Textarea.vue?vue&type=style&index=0&id=02f9c4ed&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02f9c4ed"]])

export default __exports__